export default __webpack_public_path__ + "static/media/arequipa-street_trafic_2.b4a4e841.jpg";